import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slots'
})
export class SlotsPipe implements PipeTransform {

  transform(value: string, data: { lang: string }): string {
    if (!value) return '';

    // Split the range into start and end
    const [start, end] = value.includes(' - ') ? value.split(' - ') : value.split('-');

    // Helper function to format time
    const formatTime = (time: string) => {
      if (!time) return '';

      const parts = time.trim().split(':');

      // Handle both cases: AM/PM might be in second or third part
      let hour = parts[0];
      let minute = parts[1] || '00';
      let ampm = '';

      if (parts[2]?.toUpperCase().includes('PM')) {
        ampm = data.lang === 'en' ? 'PM' : 'م';
      } else if (parts[2]?.toUpperCase().includes('AM')) {
        ampm = data.lang === 'en' ? 'AM' : 'ص';
      } else if (parts[1]?.toUpperCase().includes('PM')) {
        ampm = data.lang === 'en' ? 'PM' : 'م';
        minute = parts[1].replace(/[^0-9]/g, ''); // remove AM/PM text
      } else if (parts[1]?.toUpperCase().includes('AM')) {
        ampm = data.lang === 'en' ? 'AM' : 'ص';
        minute = parts[1].replace(/[^0-9]/g, '');
      } else {
        // default to empty if AM/PM missing
        ampm = '';
      }

      return `${hour}:${minute} ${ampm}`;
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
  }

}
